module.exports = __webpack_public_path__ + "img/nequi.a8e07db1.svg";